// extracted by mini-css-extract-plugin
export default {"dropdown":"MarkAllAsReadDropdown_dropdown__jNBHW","element":"MarkAllAsReadDropdown_element__B+K5l"};